import { render, staticRenderFns } from "./volumes.vue?vue&type=template&id=5e3a7962"
import script from "./volumes.ts?vue&type=script&lang=js&external"
export * from "./volumes.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3a7962')) {
      api.createRecord('5e3a7962', component.options)
    } else {
      api.reload('5e3a7962', component.options)
    }
    module.hot.accept("./volumes.vue?vue&type=template&id=5e3a7962", function () {
      api.rerender('5e3a7962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfe/volumes.vue"
export default component.exports